// extracted by mini-css-extract-plugin
export default {"block":"Condition_block__nsCTG","void":"Condition_void__gFQuY","text":"Condition_text__5tBfI"};